<script>
import {uploadFile} from "@/api/storeManage";

export default {
    // props: ['imageUrl','width','height','borderRadius','editing'],
    props: {
        imageUrl: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: ''
        },
        borderRadius: {
            type: String,
            default: ''
        },
        editing: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            this.selectedFile = event.target.files[0];
            this.uploadPhoto();
        },
        uploadPhoto() {
            if (!this.selectedFile) return;

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            uploadFile(formData).then(res => {
                console.log(res.data.fileUrl)
                this.$emit('updateImage', res.data.fileUrl)
            }).catch(err => {
                console.log(err);
            })
        }
    }
}
</script>

<template>
    <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
        <img :src="imageUrl" v-if="imageUrl" alt="" :style="{width: width ? width : '200px', height: height ? height : '200px', 'border-radius': borderRadius ? borderRadius : '50%'}">
        <div class="d-flex justify-content-center mt-4" v-if="editing ? true : false">
            <b-button
                class="px-5"
                variant="secondary"
                @click="triggerFileInput"
            >
                อัพโหลดรูปภาพ
            </b-button>
        </div>
        <input type="file" ref="fileInput" @change="onFileChange" style="display: none;">
    </div>
</template>

<style scoped>

</style>
